class PopupFb {
    constructor(item) {
        // Переменные
        this.element = item;
        this.openButtons = document.querySelectorAll('.js-popup-fb-open');
        this.closeButton = this.element.querySelector('.js-popup-fb-close');

        // Функции
        this.setListeners();
    };

    setListeners() {
        this.openButtons.forEach(item => {
            item.addEventListener('click', () => {
                this.element.classList.add('is-open');

                if (window.innerWidth < 768) {
                    document.body.classList.add('is-mobile-overflow');
                    document.documentElement.classList.add('is-mobile-overflow');
                }
            });
        });

        this.closeButton.addEventListener('click', () => {
            this.element.classList.remove('is-open');

            document.body.classList.remove('is-mobile-overflow');
            document.documentElement.classList.remove('is-mobile-overflow');
        });

        this.element.addEventListener('click', (event) => {
            if (event.target == this.element) {
                this.element.classList.remove('is-open');

                document.body.classList.remove('is-mobile-overflow');
                document.documentElement.classList.remove('is-mobile-overflow');
            }
        });;
    }
};

document.querySelectorAll('.js-popup-fb').forEach((item) => new PopupFb(item));
